import React, { useState } from "react";
import {
  Button,
  Card,
  Carousel,
  Col,
  Modal,
  Pagination,
  Row,
} from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import SidebarFilters from "./VehicleFinder/SidebarFilters";

const VehicleIaaIAndCopart = ({
  vehicles,
  totalItems,
  page,
  setPage,
  size,
}) => {
  const [favoriteVehicles, setFavoriteVehicles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const totalPages = Math.ceil(totalItems / size);
  const [dataVehicle, setDataVehicle] = useState(vehicles || []);

  const headerStyle = {
    backgroundColor: "#333", 
    color: "#fff", 
    textAlign: "center",
  };

  const toggleFavorite = (vehicleId) => {
    setFavoriteVehicles((prevFavorites) => {
      if (prevFavorites.includes(vehicleId)) {
        return prevFavorites.filter((id) => id !== vehicleId); // Remove from favorites
      } else {
        return [...prevFavorites, vehicleId]; // Add to favorites
      }
    });
  };

  // Open modal and set selected vehicle
  const handleDetailsClick = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowModal(true); // Show modal
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVehicle(null);
  };

  const buttonYellow = {
    backgroundColor: "#f9c74f", // Yellow
    border: "none",
    borderRadius: "10px",
    color: "#000",
    width: "120px",
    fontWeight: "bold",
  };

  const buttonBlue = {
    width: "120px",
    backgroundColor: "#007bff", // Blue
    border: "none",
    color: "#fff",
    borderRadius: "10px",
    marginBottom: "5px",
    fontWeight: "bold",
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-md-3">
          <SidebarFilters vehicles={vehicles} setDataVehicle={setDataVehicle} />
        </div>

        <div className="col-md-9">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 style={{ fontWeight: "bold", color: "#333" }}>
              {totalItems?.toLocaleString()}+ Pure Sale for Sale
            </h3>
            <div>
              <button className="btn btn-primary mx-1">Export</button>
              <button className="btn btn-secondary mx-1">Save Search</button>
              <button className="btn btn-light mx-1">Classic View</button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style={headerStyle}>Image</th>
                  <th style={headerStyle}>Lot Info</th>
                  <th style={headerStyle}>Vehicle Info</th>
                  <th style={headerStyle}>Condition</th>
                  <th style={headerStyle}>Sale Info</th>
                  <th style={headerStyle}>Bids</th>
                </tr>
              </thead>
              <tbody>
                {dataVehicle?.map((vehicle) => (
                  <tr key={vehicle?.id}>
                    <td>
                      <img
                        src={vehicle?.link_img_hd?.[0]}
                        alt={vehicle?.lotInfo}
                        className="img-fluid"
                        style={{ width: "150px", borderRadius: "4px" }}
                      />
                    </td>
                    <td>
                      <div>
                        <strong>{vehicle?.lotInfo}</strong>
                      </div>
                      <div>Lot #: {vehicle?.lot_id}</div>
                      <button
                        className="btn btn-link text-primary"
                        onClick={() => toggleFavorite(vehicle?.id)}
                      >
                        <i
                          className={`fa-solid fa-heart fa-2xl ${
                            favoriteVehicles.includes(vehicle?.id)
                              ? "text-danger"
                              : ""
                          }`}
                          style={{
                            color: favoriteVehicles.includes(vehicle?.id)
                              ? "#e40707"
                              : "black",
                          }}
                        ></i>
                      </button>
                    </td>
                    <td>
                      <div>Odometer: {vehicle?.odometer}</div>
                      <div>
                        Estimated Value: {vehicle?.estimatedValue || "N/N"}
                      </div>
                    </td>
                    <td>
                      <div>{vehicle?.title}</div>
                      <div>{vehicle?.damage_pr}</div>
                      <div>{vehicle?.keys}</div>
                    </td>
                    <td>
                      <div>{vehicle?.location}</div>
                      <div>{vehicle?.auction_type}</div>
                    </td>
                    <td>
                      <div>Current Bid: {vehicle?.current_bid}</div>
                      <button className="btn btn-sm mx-1" style={buttonBlue}>
                        Bid Now
                      </button>
                      <button
                        className="btn btn-sm mx-1"
                        style={buttonYellow}
                        onClick={() => handleDetailsClick(vehicle)}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center my-4">
            <Pagination>
              <Pagination.First
                onClick={() => setPage(1)}
                disabled={page === 1}
              />
              <Pagination.Prev
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
              />
              {[...Array(Math.min(totalPages, 5))].map((_, idx) => {
                const pageNumber = idx + Math.max(1, page - 2);
                return (
                  pageNumber <= totalPages && (
                    <Pagination.Item
                      key={pageNumber}
                      active={page === pageNumber}
                      onClick={() => setPage(pageNumber)}
                    >
                      {pageNumber}
                    </Pagination.Item>
                  )
                );
              })}
              <Pagination.Next
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
              />
              <Pagination.Last
                onClick={() => setPage(totalPages)}
                disabled={page === totalPages}
              />
            </Pagination>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Vehicle Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedVehicle && (
            <div>
              {selectedVehicle?.link_img_hd?.length > 0 && (
                <Carousel
                  interval={null}
                  nextIcon={<FaChevronRight color="#000" size={24} />}
                  prevIcon={<FaChevronLeft color="#000" size={24} />}
                >
                  {selectedVehicle?.link_img_hd?.map((img, idx) => (
                    <Carousel.Item key={idx}>
                      <img
                        src={img}
                        alt={`Slide ${idx}`}
                        className="d-block mx-auto"
                        style={{ maxHeight: "300px", borderRadius: "8px" }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              )}

              <Card className="mt-4 shadow-sm border-0">
                <Card.Body>
                  <Row>
                    <Col md={6} className="text-start">
                      <p className="text-start">
                        <strong>Lot Number:</strong> {selectedVehicle?.lot_id}
                      </p>
                      <p className="text-start">
                        <strong>Odometer:</strong> {selectedVehicle?.odometer}
                      </p>
                      <p className="text-start">
                        <strong>Estimated Value:</strong>{" "}
                        {selectedVehicle?.estimatedValue || "N/N"}
                      </p>
                      <p className="text-start">
                        <strong>Keys:</strong> {selectedVehicle?.keys}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="text-start">
                        <strong>Condition:</strong> {selectedVehicle?.title} -{" "}
                        {selectedVehicle?.damage_pr}
                      </p>
                      <p className="text-start">
                        <strong>Sale Location:</strong>{" "}
                        {selectedVehicle?.location}
                      </p>
                      <p className="text-start">
                        <strong>Auction:</strong>{" "}
                        {selectedVehicle?.auction_type}
                      </p>
                      <p className="text-start">
                        <strong>Current Bid:</strong>{" "}
                        {selectedVehicle?.current_bid}
                      </p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VehicleIaaIAndCopart;
